import React from 'react';
import { SpinnerOverlay } from './loader.styles';

const defaultProps = {
  text: '...Loading',
};

const SimpleLoader = ({ text = defaultProps.text }) => {
  return (
    <SpinnerOverlay>
      <p>{text} </p>
    </SpinnerOverlay>
  );
};

export default SimpleLoader;
